import { createServiceToken } from '@/app/di';
import type { AnalyticsPort } from './analytics.port';

export const ANALYTICS_PORT = createServiceToken<AnalyticsPort>('AnalyticsPort');
